var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "硬件厂商名称", clearable: "" },
            model: {
              value: _vm.searchData.productionCompanyName,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "productionCompanyName", $$v)
              },
              expression: "searchData.productionCompanyName"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: {
                placeholder: "语音板模块型号",
                filterable: "",
                clearable: ""
              },
              model: {
                value: _vm.searchData.hardwareModuleId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "hardwareModuleId", $$v)
                },
                expression: "searchData.hardwareModuleId"
              }
            },
            _vm._l(_vm.filterHardwareModuleList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.moduleCode, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "语音固件版本号", clearable: "" },
            model: {
              value: _vm.searchData.otaVersion,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "otaVersion", $$v)
              },
              expression: "searchData.otaVersion"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchVersionInfoList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showDialog = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.list,
            stripe: "",
            border: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  prop: item.prop,
                  label: item.label,
                  formatter: item.formatter
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "270", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "编辑", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onClickUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          title: "复制下载地址",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onClickCopyLink(scope.row)
                          }
                        }
                      },
                      [_vm._v("复制下载地址")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onClickDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.versionForm.id ? "编辑" : "新增",
            width: "520px",
            visible: _vm.showDialog,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            },
            close: _vm.onDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "versionForm",
              attrs: {
                model: _vm.versionForm,
                rules: _vm.versionFormRule,
                "label-position": "left",
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "语音固件版本号",
                    required: "",
                    prop: "otaVersion"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "语音固件版本号", clearable: "" },
                    model: {
                      value: _vm.versionForm.otaVersion,
                      callback: function($$v) {
                        _vm.$set(_vm.versionForm, "otaVersion", $$v)
                      },
                      expression: "versionForm.otaVersion"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tips" }, [
                _vm._v("提示：固件版本文件名称需与语音固件版本号一致")
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "硬件厂商名称",
                    required: "",
                    prop: "productionCompanyId"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "硬件厂商名称",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onProductionCompanyIdChange },
                      model: {
                        value: _vm.versionForm.productionCompanyId,
                        callback: function($$v) {
                          _vm.$set(_vm.versionForm, "productionCompanyId", $$v)
                        },
                        expression: "versionForm.productionCompanyId"
                      }
                    },
                    _vm._l(_vm.companyList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name + "/" + item.code,
                          value: item.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "语音板模块型号",
                    required: "",
                    prop: "hardwareModuleId"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: !_vm.versionForm.productionCompanyId,
                        placeholder: "语音板模块型号",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.onHarewareModuleIdChange },
                      model: {
                        value: _vm.versionForm.hardwareModuleId,
                        callback: function($$v) {
                          _vm.$set(_vm.versionForm, "hardwareModuleId", $$v)
                        },
                        expression: "versionForm.hardwareModuleId"
                      }
                    },
                    _vm._l(_vm.hardwareModuleList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.moduleCode, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "固件版本文件", required: "", prop: "url" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        "show-file-list": false,
                        data: {
                          otaVersion: _vm.versionForm.otaVersion,
                          firmwareType: 3,
                          moduleCode: _vm.moduleCode
                        },
                        action: "/api/versionInfo/upload",
                        "before-upload": _vm.onBeforeUpload,
                        "on-success": _vm.onFileSuccess
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.versionForm.url))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "下载方式",
                    required: "",
                    prop: "firmwareDownloadType"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.versionForm.firmwareDownloadType,
                        callback: function($$v) {
                          _vm.$set(_vm.versionForm, "firmwareDownloadType", $$v)
                        },
                        expression: "versionForm.firmwareDownloadType"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 10px 0" },
                          attrs: { label: "1", border: "" }
                        },
                        [_vm._v("监控中心发包")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { margin: "0 10px 10px 0" },
                          attrs: { label: "0", border: "" }
                        },
                        [_vm._v("URL下载")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "备注", type: "textarea" },
                    model: {
                      value: _vm.versionForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.versionForm, "remark", $$v)
                      },
                      expression: "versionForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitVersionInfo }
                    },
                    [_vm._v(_vm._s(_vm.versionForm.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "复制下载地址",
            width: "400px",
            visible: _vm.showCopy,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showCopy = $event
            },
            close: _vm.onCopyDialogClose
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "URL地址" } },
                [
                  _c("el-input", {
                    attrs: {
                      readonly: "",
                      type: "textarea",
                      rows: "8",
                      id: "copyObj"
                    },
                    model: {
                      value: _vm.currentVerion.url,
                      callback: function($$v) {
                        _vm.$set(_vm.currentVerion, "url", $$v)
                      },
                      expression: "currentVerion.url"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.copyLink } },
                    [_vm._v("复制下载地址")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCopyDialogClose } }, [
                    _vm._v("关闭")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }